import { render, staticRenderFns } from "./AuditoriaPlanosBimestrais.vue?vue&type=template&id=f2503f60"
import script from "./AuditoriaPlanosBimestrais.vue?vue&type=script&lang=js"
export * from "./AuditoriaPlanosBimestrais.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports